"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
var CardContent = function (_a) {
    var classes = _a.classes, children = _a.children, _b = _a.component, component = _b === void 0 ? 'div' : _b;
    return (react_1.default.createElement(CardContent_1.default, { classes: classes, component: component }, children));
};
exports.default = CardContent;
